export default __webpack_public_path__ + "img/heating.hero.asset.cc041bfd.jpg";